import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FaBriefcase } from 'react-icons/fa';
import { employmentTypeOptions, employmentDurationOptions } from '../utils/validators';

const WorkForm = ({ isActive, formData, handleChange, handlePrev, handleNext }) => {
    return (
        <div id="calisma-form" className={isActive ? 'd-block' : 'd-none'}>
            <h4 className="form-section-title">
                <FaBriefcase className="me-2" /> İş Bilgileri
            </h4>

            <Row className="mb-4">
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Meslek</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="occupation"
                            value={formData.occupation}
                            onChange={handleChange}
                            placeholder="Mesleğiniz"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen mesleğinizi girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Çalışma Şekli</Form.Label>
                        <Form.Select
                            required
                            name="employmentType"
                            value={formData.employmentType}
                            onChange={handleChange}
                        >
                            <option value="">Seçiniz</option>
                            {employmentTypeOptions.map((option, index) => (
                                <option key={index} value={option.value}>{option.label}</option>
                            ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Lütfen çalışma şeklinizi seçin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>İşyeri Adı</Form.Label>
                        <Form.Control
                            type="text"
                            name="workplaceName"
                            value={formData.workplaceName}
                            onChange={handleChange}
                            placeholder="Çalıştığınız işyerinin adı"
                        />
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>İş Telefonu</Form.Label>
                        <Form.Control
                            type="tel"
                            name="workPhone"
                            value={formData.workPhone}
                            onChange={handleChange}
                            placeholder="İş telefon numaranız"
                        />
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Çalışma Süresi</Form.Label>
                        <Form.Select
                            name="employmentDuration"
                            value={formData.employmentDuration}
                            onChange={handleChange}
                        >
                            <option value="">Seçiniz</option>
                            {employmentDurationOptions.map((option, index) => (
                                <option key={index} value={option.value}>{option.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Aylık Net Geliriniz</Form.Label>
                        <Form.Control
                            required
                            type="number"
                            name="income"
                            value={formData.income}
                            onChange={handleChange}
                            placeholder="Aylık geliriniz (₺)"
                            min="0"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen gelirinizi girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={12}>
                    <Form.Group className="mb-3">
                        <Form.Label>İşyeri Adresi</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="workAddress"
                            value={formData.workAddress}
                            onChange={handleChange}
                            placeholder="İşyerinizin adresi"
                        />
                    </Form.Group>
                </Col>
            </Row>

            <div className="d-flex justify-content-between">
                <Button variant="outline-secondary" onClick={handlePrev}>
                    Geri Dön
                </Button>
                <Button variant="primary" onClick={handleNext}>
                    Devam Et
                </Button>
            </div>
        </div>
    );
};

export default WorkForm;